import React, { Component, useState } from "react";
import { Alert } from "reactstrap";
import * as Columns from "./Columns.js";
import * as TabColumns from "./TabColumns.js";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TableKey from "./Key";
import Container from "react-bootstrap/Container";
import OrderTable from "./OrderTable";
import "./style.css";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
// use Theme(s)
import "react-tabulator/css/tabulator_modern.min.css";

// for React 16.4.x use: import { ReactTabulator } - example in github repo.
import { React15Tabulator, reactFormatter } from "react-tabulator"; // for React 15.x
import { msalAuth } from "../msal/MsalAuthProvider";
import { getUserDetails } from "../graph/GraphService";
export class TabOrder extends Component {
  static displayName = "IMATs Ordering";

  constructor(props) {
    super(props);
    this.state = {
      equipment: [],
      loading: true,
      readyForReview: false,
      unpicked: [],
      columns: [],
      tableWidth: 0,
      job: "",
      branch: "",
      size: "",
      notes: "",
      currency: "$",
      useUkList: false,
    };

    this.reviewOrder = this.reviewOrder.bind(this);
    this.continueOrder = this.continueOrder.bind(this);
    this.submitOrder = this.submitOrder.bind(this);
    this.download = this.download.bind(this);
    this.exportCSVFile = this.exportCSVFile.bind(this);
    this.convertToCSV = this.convertToCSV.bind(this);
    this.setJobNotes = this.setJobNotes.bind(this);
    this.toggleUkList = this.toggleUkList.bind(this);
  }

  async componentDidMount() {
    const {
      match: { params },
    } = this.props;

    var branchName = params.branchId;
    let size = params.sizeId;
    const currency = branchName === "LON" ? "£" : "$";

    // Load equipment data immediately - does not need to wait for the Graph token
    this.EquipmentData(branchName);

    // Fetch Graph user details in parallel - needed for the mailto: link at review/submit
    this.fetchUserDetails();

    //engineering and Job use the same columns.  This just removes the on-hand column
    if (branchName === "Job") {
      this.setState({ columns: TabColumns.tabJobColumns, currency, branch: branchName });
    } else if (branchName === "Engineering") {
      this.setState({
        columns: TabColumns.tabJobColumns,
        branch: branchName,
        currency,
      });
    } else if (branchName === "LON") {
      this.setState({
        columns: TabColumns.tabLonColumns,
        branch: branchName,
        currency,
      });
    } else if (size === "Small" || size === null) {
      this.setState({
        columns: TabColumns.buildTabColumns("smallDesiredQuantity", currency),
        branch: branchName,
        size: "smallDesiredQuantity",
        currency,
      });
    } else if (size === "Medium") {
      this.setState({
        columns: TabColumns.buildTabColumns("mediumDesiredQuantity", currency),
        branch: branchName,
        size: "mediumDesiredQuantity",
        currency,
      });
    } else if (size === "Large") {
      this.setState({
        columns: TabColumns.buildTabColumns("largeDesiredQuantity", currency),
        branch: branchName,
        size: "largeDesiredQuantity",
        currency,
      });
    } else {
      this.setState({
        columns: TabColumns.buildTabColumns("smallDesiredQuantity", currency),
        branch: branchName,
        size: "smallDesiredQuantity",
        currency,
      });
    }
  }

  async fetchUserDetails() {
    try {
      const accessTokenRequest = { scopes: ["user.read"] };
      var accessToken = null;
      try {
        accessToken = await msalAuth.acquireTokenSilent(accessTokenRequest);
      } catch (error) {
        console.log("acquireTokenSilent failure, trying popup");
        accessToken = await msalAuth.acquireTokenPopup(accessTokenRequest);
      }
      if (accessToken) {
        var user = await getUserDetails(accessToken);
        this.setState({ user });
      }
    } catch (err) {
      console.error("Failed to fetch user details for mailto link:", err);
    }
  }

  toggleUkList() {
    const useUkList = !this.state.useUkList;
    const currency = useUkList ? "£" : "$";
    const columns = useUkList ? TabColumns.tabLonColumns : TabColumns.tabJobColumns;
    this.setState(
      { useUkList, currency, columns, equipment: [], loading: true },
      () => {
        this.EquipmentData(useUkList ? "LON" : this.state.branch);
      }
    );
  }

  rowClick = (e, row) => {
    console.log("ref table: ", this.ref.table); // this is the Tabulator table instance
    console.log(`rowClick id: \${row.getData().id}`, row, e);
    this.setState({ selectedName: row.getData().name });
  };

  setData = () => {
    this.setState(this.state.equipment);
  };

  reviewOrder() {
    console.log("we are reviewing the order now");
    const {
      match: { params },
    } = this.props;
    var branchName = params.branchId;
    if (branchName === "Job" && this.state.notes == "") {
      alert("Please input job information to continue your order");
      return;
    }
    this.setState({
      readyForReview: true,
      equipment: this.state.equipment.filter(function (item) {
        return item.quantity > 0;
      }),
      unpicked: this.state.equipment.filter(function (item) {
        return item.quantity == 0;
      }),
    });
  }
  continueOrder() {
    let data = this.state.equipment.concat(this.state.unpicked);

    let sorted = []
      .concat(data)
      .sort((a, b) => (a.typeOfEquipment > b.typeOfEquipment ? 1 : -1));

    this.setState({
      equipment: sorted,
      readyForReview: false,
      unpicked: [],
    });
  }
  setJobNotes() {
    let value = document.getElementById("jobNumber").value;

    this.setState(
      {
        notes: value,
      },
      () => { }
    );
  }

  renderBranchOrderTable() {
    return (
      <div>
        <React15Tabulator
          columns={this.state.columns}
          data={this.state.equipment}
          footerElement={<span>CTI Imaterials</span>}
          height={"500px"}
          layout={"fitColumns"}
        />
      </div>
    );
  }

  render() {
    const {
      match: { params },
    } = this.props;

    let branchName = params.branchId;
    let header = this.state.branch == "" ? branchName : this.state.branch;
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderBranchOrderTable()
    );

    if (
      !this.state.readyForReview &&
      branchName != "Job" &&
      branchName != "Engineering"
    ) {
      return (
        <div>
          <h1>{branchName} Order</h1>
          <TableKey />
          {contents}
          <button className="btn btn-primary" onClick={this.reviewOrder}>
            Review Order
          </button>
        </div>
      );
    }
    if (!this.state.readyForReview) {
      var label = "";
      if (this.state.branch == "Job") {
        label =
          "Input Job Number and notes.  Information added will be sent to purchasing.";
      }

      return (
        <>
          <Container
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <h1 style={{ width: "auto" }}>{header} Order</h1>

            <div style={{ marginBottom: "10px" }}>
              <button
                className={`btn ${
                  this.state.useUkList ? "btn-secondary" : "btn-outline-secondary"
                }`}
                onClick={this.toggleUkList}
                style={{ marginRight: "8px" }}
              >
                {this.state.useUkList ? "🇬🇧 UK List" : "🇺🇸 US List"}
              </button>
            </div>

            <InputGroup
              className="mb-3"
              style={{ width: "70%", margin: "0 auto" }}
            >
              <FormControl
                id="jobNumber"
                placeholder="Job Information"
                aria-label="Notes"
                aria-describedby="basic-addon2"
              />
              <InputGroup.Append>
                <Button onClick={this.setJobNotes} variant="outline-secondary">
                  Submit
                </Button>
              </InputGroup.Append>
            </InputGroup>
            <h5>Job Info: {this.state.notes}</h5>

            <label>{label}</label>

            {/* <TableKey style={{marginTop:'15px;'}} /> */}
            {contents}
            <div>
              <button className="btn btn-primary" onClick={this.reviewOrder}>
                Review Order
              </button>
            </div>
          </Container>
        </>
      );
    }
    if (this.state.readyForReview && this.state.branch != "Engineering") {
      var orderEmail = this.state.branch === "LON" ? "LONOrders@cti.com" : "Orders@conferencetech.com";
      var mailTo =
        "mailto:" +
        orderEmail +
        "?cc=" +
        (this.state.user?.mail ?? "") +
        "&subject=New%20Imaterials%20Order&body=" +
        (this.state.user?.displayName ?? "") +
        "%20has%20placed%20a%20new%20Imaterials%20order.%20%20Please%20check%20and%20review%20attached%20files.%20" +
        this.state.notes +
        "%20";
      return (
        <div>
          <h1>{branchName} Review Order</h1>
          {contents}
          <button className="btn btn-primary" onClick={this.continueOrder}>
            Continue Order
          </button>
          <a href={mailTo}>
            <button
              style={{ margin: "5px" }}
              className="btn btn-primary"
              onClick={this.submitOrder}
            >
              Submit Order
            </button>
          </a>
        </div>
      );
    }
    if (this.state.readyForReview && this.state.branch === "Engineering") {
      return (
        <div>
          <h1>{branchName} Review Order</h1>
          {contents}
          <button className="btn btn-primary" onClick={this.continueOrder}>
            Continue Order
          </button>

          <button
            style={{ margin: "5px" }}
            className="btn btn-primary"
            onClick={this.submitOrder}
          >
            Sign Off
          </button>
        </div>
      );
    }
  }
  //put these all in a button component
  //pass in equipment state and do everything in that component
  submitOrder() {
    this.download();
  }
  convertToCSV(objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
      var line = "";
      for (var index in array[i]) {
        if (line != "") line += ",";

        line += array[i][index];
      }

      str += line + "\r\n";
    }

    return str;
  }
  exportCSVFile(headers, items, fileTitle) {
    if (this.state.branch != "Engineering") {
      alert(
        "Your file is now downloading.  You're primary email application will now open.  Please drag and drop the file into the email and send it for final approval.  Thanks!"
      );
    }
    if (headers) {
      items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var csv = this.convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + ".csv" || "export.csv";

    var blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+

      navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute

        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  download() {
    const {
      match: { params },
    } = this.props;
    var branchName = params.branchId;
    var itemsNotFormatted = this.state.equipment;
    var itemsFormatted = [];

    // format the data

    if (branchName == "Engineering") {
      var headers = {
        description: "Description".replace(/,/g, ""), // remove commas to avoid errors
        vendor: "Vendor",
        newPartNumber: "Part Number",
        quantity: "Quantity",
        cost: "Cost Per",
        unitOfMeasure: "Measure",
        itemCost: "Item Cost",
      };

      var totalCost = 0;

      itemsNotFormatted.forEach((item) => {
        let itemCost = item.quantity * item.cost;
        totalCost = totalCost + itemCost;
        //doing some really stupid shit to spoof a footer
      });
      let totalSlop = totalCost + totalCost * 0.05;

      itemsNotFormatted.forEach((item) => {
        let itemCost = item.quantity * item.cost;

        itemsFormatted.push({
          description: item.description?.toString().replace(/,/g, ""), // remove commas to avoid errors,
          vendor: item.vendor,
          newPartNumber: '="' + (item.newPartNumber || "").toString().replace(/,/g, "") + '"',
          cost: this.state.currency + item.cost.toFixed(2),
          unitOfMeasure: item.unitOfMeasure?.toString().replace(/,/g, "") || "",
          quantity: item.quantity.toString().replace(/,/g, ""),
          itemCost: this.state.currency + itemCost.toFixed(2),
        });
      });

      itemsFormatted.push({
        vendor: " ",
        newPartNumber: " ",
        description: " ",
        partNumber: " ",
        cost: " ",
        unitOfMeasure: "Total: ",
        quantity: " ",
        itemCost: this.state.currency + Number(totalCost).toFixed(2),
      });
      itemsFormatted.push({
        vendor: " ",
        newPartNumber: " ",
        description: " ",
        cost: " ",
        unitOfMeasure: "Signoff Total: ",
        quantity: " ",
        itemCost: this.state.currency + Number(totalSlop).toFixed(2),
      });
    } else {
      var headers = {
        vendor: "Vendor",
        newPartNumber: "Part Number",
        description: "Description".replace(/,/g, ""), // remove commas to avoid errors
        cost: "Cost Per",
        unitOfMeasure: "Measure",
        quantity: "Quantity",
        itemCost: "Item Cost",
      };

      itemsNotFormatted.forEach((item) => {
        let itemCost = item.quantity * item.cost;

        itemsFormatted.push({
          vendor: item.vendor,
          newPartNumber: '="' + (item.newPartNumber || "").replace(/,/g, "") + '"',
          description: item.description?.replace(/,/g, ""), // remove commas to avoid errors,
          cost: this.state.currency + item.cost.toFixed(2),
          unitOfMeasure: item.unitOfMeasure?.toString().replace(/,/g, "") || "",
          quantity: item.quantity?.toString().replace(/,/g, ""),
          itemCost: this.state.currency + itemCost.toFixed(2),
        });
      });
    }

    var today = new Date();

    var date =
      +(today.getMonth() + 1) +
      "-" +
      today.getDate() +
      "-" +
      today.getFullYear();

    if (branchName == "Job" || branchName == "Engineering") {
      var fileTitle = this.state.notes + "_Order" + "_" + date; // or 'my-unique-title'
    } else {
      var fileTitle = branchName + "_Order" + "_" + date; // or 'my-unique-title'
    }

    this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
  }

  async EquipmentData(branchName) {
    const url = branchName
      ? "equipment?branch=" + encodeURIComponent(branchName)
      : "equipment";
    const response = await fetch(url);

    var data = await response.json();

    console.log(data);

    if (
      branchName != "ATL" &&
      branchName != "Job" &&
      branchName != "Engineering" &&
      branchName != "LON"
    ) {
      data = data.filter((item) => item.typeOfEquipment != "Belden Cable");
    }
    this.setState({ equipment: data, loading: false });
  }
}
